import { styled } from '@mui/material';
import { ConnectionQuality } from 'livekit-client';
import Iconify from 'src/components/iconify/Iconify';
import { ConnectionStatus } from 'src/provider/VoiceChannel';
import { CustomChannelTitle } from './styles';

const ERROR_STATUS: ConnectionStatus[] = [
  'connecting',
  'disconnected',
  'error',
  'reconnecting',
];

const StyledIcon = styled(Iconify)(() => ({ minWidth: 20 }));

type Props = {
  connectionStatus: string;
  connectionQuality: number | ConnectionQuality;
};

export const ConnectionStatusIcon = ({
  connectionStatus,
  connectionQuality,
}: Props) => {
  if (connectionStatus !== 'connected')
    return (
      <>
        <StyledIcon icon="line-md:loading-twotone-loop" />
        <CustomChannelTitle variant="subtitle2" color="text.secondary" ml={0.5}>
          {connectionStatus}...
        </CustomChannelTitle>
      </>
    );

  if (ERROR_STATUS.includes(connectionStatus)) {
    return <StyledIcon icon="tabler:antenna-bars-1" color="red" />;
  }

  if (
    (connectionQuality as number) > 75 ||
    connectionQuality === ConnectionQuality.Excellent
  ) {
    return <StyledIcon icon="tabler:antenna-bars-5" color="#00cb5f" />;
  }

  if (
    (connectionQuality as number) > 50 ||
    connectionQuality === ConnectionQuality.Good
  ) {
    return <StyledIcon icon="tabler:antenna-bars-4" color="orange" />;
  }

  return <StyledIcon icon="tabler:antenna-bars-3" color="red" />;
};

const ConectionStatusContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 1, 2, 1),
  // borderBottom: '1px solid',
  // borderColor: 'divider',
  marginBottom: 2,
  width: '100%',
}));
